import useAuthorisation from "./useAuthorisation";

export const useProtectedContent = (allowedRoles) => {
  const { authorisation } = useAuthorisation();

  const getTrueKeys = (obj) =>
    Object.keys(obj).filter((key) => obj[key] === true);

  const userRoles = getTrueKeys(authorisation?.roles);

  if (
    !authorisation.loading &&
    userRoles.find((role) => allowedRoles?.includes(role))
  ) {
    return true;
  }
  return false;
};
